var _desc, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoClicked(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created using Figma")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo-clicked_svg__logo-clicked_svg__Canvas",
    transform: "translate(11824 -3155)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo-clicked_svg__logo-clicked_svg__Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo-clicked_svg__logo-clicked_svg__Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo-clicked_svg__logo-clicked_svg__Oval_2"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#logo-clicked_svg__logo-clicked_svg__path0_fill",
    transform: "matrix(0.956305 -0.292372 0.292372 0.956305 -11829.3 3163.52)",
    fill: "#494949"
  })), /*#__PURE__*/React.createElement("g", {
    id: "logo-clicked_svg__logo-clicked_svg__Line_(Stroke)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#logo-clicked_svg__logo-clicked_svg__path1_fill",
    transform: "matrix(0.699718 0.714419 -0.699612 0.714523 -11806.3 3171.17)",
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "logo-clicked_svg__logo-clicked_svg__Line_(Stroke)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#logo-clicked_svg__logo-clicked_svg__path2_fill",
    transform: "matrix(0.699612 -0.714523 0.699718 0.714419 -11807.7 3189.94)",
    fill: "#FFFFFF"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "logo-clicked_svg__logo-clicked_svg__path0_fill",
    fillRule: "evenodd",
    d: "M 25 50C 38.8071 50 50 38.8071 50 25C 50 11.1929 38.8071 0 25 0C 11.1929 0 0 11.1929 0 25C 0 38.8071 11.1929 50 25 50Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "logo-clicked_svg__logo-clicked_svg__path1_fill",
    fillRule: "evenodd",
    d: "M 26.0056 1.02564C 26.0056 1.59208 25.5464 2.05127 24.98 2.05127L 1.02564 2.05127C 0.459193 2.05127 0 1.59208 0 1.02564L 0 1.02564C 0 0.459193 0.459193 0 1.02564 0L 24.98 0C 25.5464 0 26.0056 0.459193 26.0056 1.02564L 26.0056 1.02564Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "logo-clicked_svg__logo-clicked_svg__path2_fill",
    fillRule: "evenodd",
    d: "M 25.6409 1.04022C 25.6409 1.61472 25.1752 2.08045 24.6007 2.08045L 1.04022 2.08045C 0.465724 2.08045 0 1.61472 0 1.04022L 0 1.04022C 0 0.465724 0.465724 0 1.04022 0L 24.6007 0C 25.1752 0 25.6409 0.465724 25.6409 1.04022L 25.6409 1.04022Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoClicked);
export default __webpack_public_path__ + "static/media/logo-clicked.13cf5e325538166b810242d156d58112.svg";
export { ForwardRef as ReactComponent };